import type { ReactNode } from "react";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import type { TooltipBodyProps } from "@design-system/Tooltip/Tooltip.types";
import styles from "./AvatarTooltip.module.scss";

type AvatarTooltipProps = TooltipBodyProps & { children: ReactNode };

/**
 * A tooltip on an avatar, e.g. in an `AvatarGroup`'s `renderAvatar`. The
 * wrapping span is the trigger because `Avatar` takes a ref but not the
 * props Base UI merges onto a trigger.
 */
export const AvatarTooltip = ({ children, ...body }: AvatarTooltipProps) => (
    <Tooltip {...body}>
        <span className={styles.trigger}>{children}</span>
    </Tooltip>
);
